import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase, Grid, Typography } from '@material-ui/core';
import GuideMessage from '../components/message/GuideMessage';
import { AuthTabs, SocialButton, OrDivider, EmailLoginForm } from '../components/auth';
import { CustomVacantButton } from '../components/button';
import tokens from '../components/theme/tokens';

// 로그인 — 개인회원: 소셜(네이버·카카오는 준비중, 구글만 열림) + 이메일 / 기업회원: 이메일 로그인. 가입은 /signup 으로
const SOCIAL_READY = { naver: false, kakao: false, google: true };
const PREPARING = '준비중';

const useStyles = makeStyles((theme) => ({
  wrap: {
    paddingTop: 100,
    paddingBottom: 180,
    [theme.breakpoints.down('sm')]: { paddingTop: 30, paddingBottom: 100 },
  },
  card: {
    width: 420,
    maxWidth: 'calc(100vw - 40px)',
  },
  tabs: { marginTop: 40, marginBottom: 24 },
  social: { width: '100%' },
  signup: {
    marginTop: 14,
    height: 52,
    fontSize: 16,
  },
  foot: {
    marginTop: 28,
    textAlign: 'center',
    fontSize: 14,
    color: tokens.muted,
    letterSpacing: -0.4,
  },
  footLink: {
    marginLeft: 6,
    fontSize: 14,
    fontWeight: 700,
    color: tokens.primaryDark,
    textDecoration: 'underline',
  },
}));

function LoginPage({ history, loginStore }) {
  const cs = useStyles();
  const { googleLoginInit, emailLogin, snsCallback } = loginStore;
  const [tab, setTab] = useState('Private');
  const savedId = (() => { try { return localStorage.getItem('qadmid') || ''; } catch (e) { return ''; } })();

  useEffect(() => {
    snsCallback();
  }, [snsCallback]);

  // 구글 버튼은 탭을 바꿔 다시 그려질 때마다 SDK 클릭 핸들러를 다시 단다
  useEffect(() => {
    if (tab === 'Private' && SOCIAL_READY.google) googleLoginInit();
  }, [tab, googleLoginInit]);

  const go = (path, state) => history.push(state ? { pathname: path, state } : path);
  const login = (params) => emailLogin(params, history);

  return (
    <Grid container direction="row" justify="center" wrap="nowrap" className={cs.wrap}>
      <Grid item className={cs.card}>
        <Grid container direction="column" alignItems="center">
          <GuideMessage
            title="로그인이 필요하신가요?"
            mTitle="로그인"
            resultTitle="로그인이 필요하신가요?"
            subTitle="로그인하시면 서비스 이용이 더 편해집니다."
          />
        </Grid>
        <AuthTabs className={cs.tabs} value={tab} onChange={setTab} />

        {tab === 'Private' && (
          <React.Fragment>
            <div className={cs.social}>
              <SocialButton provider="naver" disabled={!SOCIAL_READY.naver} note={PREPARING} />
              <SocialButton provider="kakao" disabled={!SOCIAL_READY.kakao} note={PREPARING} />
              <SocialButton provider="google" id="googleBtn" disabled={!SOCIAL_READY.google} note={PREPARING} />
            </div>
            <OrDivider />
          </React.Fragment>
        )}

        <EmailLoginForm
          key={tab}
          initialEmail={savedId}
          onSubmit={login}
          onFindId={() => go('/idInquiry')}
          onFindPwd={() => go('/pwInquiry')}
        />
        <CustomVacantButton
          className={cs.signup}
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => go('/signup', { userType: tab })}
        >
          {tab === 'Company' ? '기업회원 가입' : '초간단 회원가입'}
        </CustomVacantButton>

        <Typography component="div" className={cs.foot}>
          {tab === 'Company' ? '개인 고객이신가요?' : '기업 고객이신가요?'}
          <ButtonBase className={cs.footLink} onClick={() => setTab(tab === 'Company' ? 'Private' : 'Company')} focusRipple={false}>
            {tab === 'Company' ? '개인회원 로그인' : '기업회원 로그인'}
          </ButtonBase>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default inject('loginStore')(observer(LoginPage));
